import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { resetDevice } from "../api";

export default function Register() {
  const { register, login } = useAuth();
  const [mode, setMode] = useState("new");
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("user");
  const [pwd, setPwd] = useState("");
  const [adminSecret, setAdminSecret] = useState("");
  const [gpsMsg, setGpsMsg] = useState("");
  const [loadingReg, setLoadingReg] = useState(false);
  const [loadingReset, setLoadingReset] = useState(false);

  const ADMIN_PW = "secret";

  const onRegister = async () => {
    if (!username) return toast.error("Enter a username");
    if (role === "admin" && pwd !== ADMIN_PW) {
      return toast.error("Wrong admin password");
    }
    setLoadingReg(true);
    try {
      await register({ username, role });
      toast.success("Registered successfully!");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoadingReg(false);
    }
  };

  const onReset = async () => {
    if (!username || !adminSecret)
      return toast.error("Enter both username & admin secret");
    const newDeviceId = uuidv4();
    setLoadingReset(true);
    try {

      // const json = await resetDevice(username, adminSecret, newDeviceId);      
      // if (!json.success) throw new Error(json.error || "Reset failed");
      // login({ username, role: "user", deviceId: newDeviceId });

      const json = await resetDevice(username, adminSecret, newDeviceId);
      if (!json.success || !json.employee) {
      const err = json.error || "Reset failed - no employee data";
      throw new Error(err);
    }
      // Pull role back from the server so we keep 'admin' if applicable
      const { username: u, role: r, deviceId: d } = json.employee;
      login({ username: u, role: r, deviceId: d });

      toast.success("Device reset successful!");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoadingReset(false);
    }
  };

const handleAllowLocation = () => {
  if (!navigator.geolocation) {
    setGpsMsg("Geolocation not supported");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const { latitude, longitude, accuracy } = pos.coords;
      setGpsMsg(`✅ Location allowed (${latitude.toFixed(5)}, ${longitude.toFixed(5)}, ±${accuracy}m)`);
    },
    (err) => {
      setGpsMsg(`❌ ${err.message}`);
    },
    { enableHighAccuracy: true }
  );
};

  const styles = {
    container: {
      maxWidth: 360,
      margin: "40px auto",
      padding: 20,
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      fontFamily: "sans-serif",
    },
    heading: { textAlign: "center", marginBottom: 20, color: "#333" },
    toggleBar: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20,
    },
    toggleBtn: (active) => ({
      flex: 1,
      padding: "10px 0",
      margin: "0 4px",
      border: "none",
      borderRadius: 6,
      background: active ? "#1976d2" : "#e0e0e0",
      color: active ? "#fff" : "#555",
      fontWeight: active ? 600 : 400,
      cursor: active ? "default" : "pointer",
    }),
    input: {
      width: "100%",
      padding: 12,
      marginBottom: 16,
      border: "1px solid #ccc",
      borderRadius: 6,
      fontSize: 16,
      outline: "none",
    },
    actionBtn: {
      width: "100%",
      padding: 12,
      border: "none",
      borderRadius: 6,
      background: "#1976d2",
      color: "#fff",
      fontSize: 16,
      fontWeight: 600,
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        {mode === "new" ? "Register" : "Reset Device"}
      </h2>

      <div style={styles.toggleBar}>
        <button
          style={styles.toggleBtn(mode === "new")}
          onClick={() => setMode("new")}
          disabled={mode === "new"}
        >
          New
        </button>
        <button
          style={styles.toggleBtn(mode === "reset")}
          onClick={() => setMode("reset")}
          disabled={mode === "reset"}
        >
          Reset
        </button>
      </div>

      <input
        style={styles.input}
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      {mode === "new" ? (
        <>
          <div style={{ display: "flex", justifyContent: "space-around", marginBottom: 16 }}>
            <label>
              <input
                type="radio"
                name="role"
                value="user"
                checked={role === "user"}
                onChange={() => setRole("user")}
              />{" "}
              User
            </label>
            <label>
              <input
                type="radio"
                name="role"
                value="admin"
                checked={role === "admin"}
                onChange={() => setRole("admin")}
              />{" "}
              Admin
            </label>
          </div>

          {role === "admin" && (
            <input
              style={styles.input}
              type="password"
              placeholder="Admin Password"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
            />
          )}

          

          <button
            style={{ ...styles.actionBtn, opacity: loadingReg ? 0.7 : 1 }}
            onClick={onRegister}
            disabled={loadingReg}
          >
            {loadingReg ? "Registering..." : "Submit"}
          </button>


          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, marginTop:16 }}>
  <button
    onClick={handleAllowLocation}
    style={{
      padding: "8px 16px",
      background: "#1976d2",
      color: "#fff",
      border: "none",
      borderRadius: 6,
      fontWeight: 600,
      cursor: "pointer",
      fontSize: 14,
    }}
  >
    Allow Location
  </button>
  {gpsMsg && <span style={{ fontSize: 13, color: "#555" }}>{gpsMsg}</span>}
</div>
        </>
      ) : (
        <>
          <input
            style={styles.input}
            type="password"
            placeholder="Admin Secret"
            value={adminSecret}
            onChange={(e) => setAdminSecret(e.target.value)}
          />
          <button
            style={{ ...styles.actionBtn, opacity: loadingReset ? 0.7 : 1, marginTop: 8 }}
            onClick={onReset}
            disabled={loadingReset}
          >
            {loadingReset ? "Resetting..." : "Reset My Device"}
          </button>
        </>
      )}
    </div>
  );
}



// // src/screens/Register.js
// import React, { useState } from "react";
// import { useAuth } from "../hooks/useAuth";
// import { v4 as uuidv4 } from "uuid";
// import { toast } from "react-toastify";
// import { resetDevice } from "../api";

// export default function Register() {
//   const { register, login } = useAuth();
//   const [mode, setMode] = useState("new"); // "new" | "reset"
//   const [username, setUsername] = useState("");
//   const [role, setRole] = useState("user");
//   const [pwd, setPwd] = useState("");
//   const [adminSecret, setAdminSecret] = useState("");

//   const ADMIN_PW = "secret";    // for new-admin registration
//   const ADMIN_RESET = "";       // not needed here

//   const onRegister = async () => {
//     if (!username) return toast.error("Enter name");
//     if (role === "admin" && pwd !== ADMIN_PW) {
//       return toast.error("Wrong password");
//     }
//     try {
//       await register({ username, role });
//       toast.success("Registered successfully!");
//     } catch (e) {
//       toast.error(e.message);
//     }
//   };

// const onReset = async () => {
//   if (!username || !adminSecret) {
//     return toast.error("Enter both username & admin secret");
//   }
//   const newDeviceId = uuidv4();
//   try {
//     const json = await resetDevice(username, adminSecret, newDeviceId);
//     if (!json.success) throw new Error(json.error || "Reset failed");

//     // Persist locally so app treats this as "logged in"
//     // const user = { username, role: "user", deviceId: newDeviceId };
//     // localStorage.setItem("attendanceUser", JSON.stringify(user));
//     // setUser(user);
//     login({ username, role: "user", deviceId: newDeviceId });
//     toast.success("Device reset successful!");
//   } catch (e) {
//     toast.error(e.message);
//   }
// };

//   const styles = {
//     container: {
//       maxWidth: 360,
//       margin: "40px auto",
//       padding: 20,
//       background: "#fff",
//       borderRadius: 12,
//       boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//       fontFamily: "sans-serif",
//     },
//     heading: { textAlign: "center", marginBottom: 20, color: "#333" },
//     toggleBar: {
//       display: "flex",
//       justifyContent: "center",
//       marginBottom: 20,
//     },
//     toggleBtn: (active) => ({
//       flex: 1,
//       padding: "10px 0",
//       margin: "0 4px",
//       border: "none",
//       borderRadius: 6,
//       background: active ? "#1976d2" : "#e0e0e0",
//       color: active ? "#fff" : "#555",
//       fontWeight: active ? 600 : 400,
//       cursor: active ? "default" : "pointer",
//     }),
//     input: {
//       width: "100%",
//       padding: 12,
//       marginBottom: 16,
//       border: "1px solid #ccc",
//       borderRadius: 6,
//       fontSize: 16,
//       outline: "none",
//     },
//     radioGroup: { display: "flex", justifyContent: "space-around", marginBottom: 16 },
//     radioLabel: { display: "flex", alignItems: "center", fontSize: 16, color: "#444" },
//     radioInput: { marginRight: 8 },
//     actionBtn: {
//       width: "100%",
//       padding: 12,
//       border: "none",
//       borderRadius: 6,
//       background: "#1976d2",
//       color: "#fff",
//       fontSize: 16,
//       fontWeight: 600,
//       cursor: "pointer",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.heading}>
//         {mode === "new" ? "Register" : "Reset Device"}
//       </h2>

//       <div style={styles.toggleBar}>
//         <button
//           style={styles.toggleBtn(mode === "new")}
//           onClick={() => setMode("new")}
//           disabled={mode === "new"}
//         >
//           New
//         </button>
//         <button
//           style={styles.toggleBtn(mode === "reset")}
//           onClick={() => setMode("reset")}
//           disabled={mode === "reset"}
//         >
//           Reset
//         </button>
//       </div>

//       <input
//         style={styles.input}
//         placeholder="Username"
//         value={username}
//         onChange={(e) => setUsername(e.target.value)}
//       />

//       {mode === "new" ? (
//         <>
//           <div style={styles.radioGroup}>
//             <label style={styles.radioLabel}>
//               <input
//                 style={styles.radioInput}
//                 type="radio"
//                 name="role"
//                 value="user"
//                 checked={role === "user"}
//                 onChange={() => setRole("user")}
//               />
//               User
//             </label>
//             <label style={styles.radioLabel}>
//               <input
//                 style={styles.radioInput}
//                 type="radio"
//                 name="role"
//                 value="admin"
//                 checked={role === "admin"}
//                 onChange={() => setRole("admin")}
//               />
//               Admin
//             </label>
//           </div>

//           {role === "admin" && (
//             <input
//               style={styles.input}
//               type="password"
//               placeholder="Admin Password"
//               value={pwd}
//               onChange={(e) => setPwd(e.target.value)}
//             />
//           )}

//           <button style={styles.actionBtn} onClick={onRegister}>
//             Submit
//           </button>
//         </>
//       ) : (
//         <>
//           <input
//             style={styles.input}
//             type="password"
//             placeholder="Admin Secret"
//             value={adminSecret}
//             onChange={(e) => setAdminSecret(e.target.value)}
//           />
//           <button style={styles.actionBtn} onClick={onReset}>
//             Reset My Device
//           </button>
//         </>
//       )}
//     </div>
//   );
// }


    // <div style={{ padding: 20 }}>
    //   <h2>{mode === "new" ? "Register" : "Reset Device"}</h2>
    //   <div style={{ marginBottom: 10 }}>
    //     <button onClick={() => setMode("new")} disabled={mode === "new"}>
    //       New Registration
    //     </button>
    //     <button onClick={() => setMode("reset")} disabled={mode === "reset"}>
    //       Reset Device
    //     </button>
    //   </div>

    //   {/* COMMON USERNAME FIELD */}
    //   <div style={{ marginBottom: 10 }}>
    //     <input
    //       placeholder="Your username"
    //       value={username}
    //       onChange={(e) => setUsername(e.target.value)}
    //     />
    //   </div>

    //   {mode === "new" ? (
    //     <>
    //       {/* ROLE SELECTION */}
    //       <div>
    //         <label>
    //           <input
    //             type="radio"
    //             name="role"
    //             value="user"
    //             checked={role === "user"}
    //             onChange={() => setRole("user")}
    //           />{" "}
    //           User
    //         </label>
    //         <label style={{ marginLeft: 10 }}>
    //           <input
    //             type="radio"
    //             name="role"
    //             value="admin"
    //             checked={role === "admin"}
    //             onChange={() => setRole("admin")}
    //           />{" "}
    //           Admin
    //         </label>
    //       </div>
    //       {/* ADMIN PASSWORD FOR NEW REG */}
    //       {role === "admin" && (
    //         <div style={{ marginTop: 10 }}>
    //           <input
    //             placeholder="Admin Password"
    //             type="password"
    //             value={pwd}
    //             onChange={(e) => setPwd(e.target.value)}
    //           />
    //         </div>
    //       )}
    //       <div style={{ marginTop: 10 }}>
    //         <button onClick={onRegister}>Submit</button>
    //       </div>
    //     </>
    //   ) : (
    //     <>
    //       {/* RESET MODE: ADMIN SECRET */}
    //       <div style={{ marginTop: 10 }}>
    //         <input
    //           placeholder="Admin Secret"
    //           type="password"
    //           value={adminSecret}
    //           onChange={(e) => setAdminSecret(e.target.value)}
    //         />
    //       </div>
    //       <div style={{ marginTop: 10 }}>
    //         <button onClick={onReset}>Reset My Device</button>
    //       </div>
    //     </>
    //   )}
    // </div>

// import React, { useState } from "react";
// import { useAuth } from "../hooks/useAuth";
// import { toast } from "react-toastify";

// export default function Register() {
//   const { register } = useAuth();
//   const [username, setUsername] = useState("");
//   const [role, setRole]     = useState("user"); // or "admin"
//   const [pwd, setPwd]       = useState("");
//   const ADMIN_PW = "secret";

//   const onSubmit = async () => {
//     if (!username) return toast.error("Enter name");
//     if (role==="admin" && pwd !== ADMIN_PW) return toast.error("Wrong password");
//     try {
//       await register({ username, role });
//       toast.success("Registered!");
//     } catch (err) {
//       toast.error(err.message);
//     }
//   };
// }

//     return (
//     <div style={{ padding: 20 }}>
//       <h2>Register</h2>
//       <div>
//         <label>
//           <input
//             type="radio"
//             name="role"
//             value="user"
//             checked={role === "user"}
//             onChange={() => setRole("user")}
//           />
//           User
//         </label>
//         <label style={{ marginLeft: 10 }}>
//           <input
//             type="radio"
//             name="role"
//             value="admin"
//             checked={role === "admin"}
//             onChange={() => setRole("admin")}
//           />
//           Admin
//         </label>
//       </div>
//       {role === "admin" && (
//         <div style={{ marginTop: 10 }}>
//           <input
//             placeholder="Admin Password"
//             type="password"
//             value={pwd}
//             onChange={(e) => setPwd(e.target.value)}
//           />
//         </div>
//       )}
//       <div style={{ marginTop: 10 }}>
//         <input
//           placeholder="Your name"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//         />
//       </div>
//       <button onClick={onSubmit} style={{ marginTop: 10 }}>
//         Submit
//       </button>
//     </div>
//   );
  // return (
  //   <div style={{ padding: 20 }}>
  //     <h2>Register</h2>
  //     <div>
  //       <label><input type="radio" name="role" value="user" checked={role==="user"} onChange={()=>setRole("user")} />User</label>
  //       <label><input type="radio" name="role" value="admin" checked={role==="admin"} onChange={()=>setRole("admin")} />Admin</label>
  //     </div>
  //     {role==="admin" && <input placeholder="Admin Password" type="password" value={pwd} onChange={e=>setPwd(e.target.value)} />}
  //     <input placeholder="Your name" value={username} onChange={e=>setUsername(e.target.value)} />
  //     <button onClick={onSubmit}>Submit</button>
  //   </div>
  // );

